import {ConfigurationApiService} from 'src/app/core/api/configuration-api.service';
import {take} from 'rxjs/operators';
import {selectConfiguration} from 'src/app/core/store/workspace/workspace.selector';
import {Observable} from 'rxjs';
import {LogoutAction} from 'src/app/core/store/auth/auth.action';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  EventEmitter,
} from '@angular/core';
import {Router} from '@angular/router';
import {Store, select} from '@ngrx/store';
import {Application} from 'src/app/core/models/application';
import {MenuItemsTracking} from 'src/app/core/models/menu-items-tracking';
import {Constants} from 'src/app/shared/constants';
import {Configuration} from 'src/app/core/models/configuration';

@Component({
  selector: 'tracking-drawer-nav',
  templateUrl: './tracking-drawer-nav.component.html',
  styleUrls: ['./tracking-drawer-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrackingDrawerNavComponent implements OnInit, OnChanges {
  @Input()
  public applications: Application[];

  @Input()
  public username: string;

  @Input()
  public mobile: boolean;

  @Output()
  public collapse = new EventEmitter();

  public applicationsMap: Record<string, Application> = {};

  public menuItems: MenuItemsTracking[];
  public activeRoute: string;

  public configuration$: Observable<Configuration>;

  constructor(
    private configurationApiService: ConfigurationApiService,
    private constants: Constants,
    public router: Router,
    private store$: Store
  ) {}

  ngOnInit(): void {
    this.configuration$ = this.store$.pipe(select(selectConfiguration));
    const urlTree = this.router.parseUrl(this.router.url);
    this.activeRoute = `/${urlTree.root.children['primary'].segments[0].path}`;
    this.menuItems = this.constants.MOBILE_MENU_ITEMS_TRACKING.map(m => {
      // Set initial icon img src
      // to be toggled later on hover & activeRoute change
      m.iconSrc = m.address === this.activeRoute ? m.activeIcon : m.inactiveIcon;
      return m;
    });
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.applications && this.applications) {
      this.applicationsMap = this.applications.reduce((appsMap, app) => ((appsMap[app.id] = app), appsMap), {});
      //TODO: remove when data is sent from backend
      this.applicationsMap['PieceInspectR'] = this.applicationsMap['BatchInspectR'];
    }
  }

  public onLogoutClick() {
    this.store$.dispatch(new LogoutAction());
  }

  public onNavItem(name: string) {
    this.configuration$.pipe(take(1)).subscribe(configuration => {
      const application = configuration.applications.find(app => app.id === this.findAppId(name));
      if (application) {
        this.configurationApiService.sendLogInfo(application.appGuid).subscribe();
      }
    });
  }

  public findAppId(name: string) {
    switch (name) {
      case 'Gateway Batch Manager':
        return 'GBM';
      case 'Files Search':
        return 'Documents';
      default:
        return name.replace(' ', '');
    }
  }

  public onCollapse() {
    this.collapse.emit();
  }
}
